import { ApolloClient } from 'apollo-client'
import { createHttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { setContext } from 'apollo-link-context'

const authLink = setContext((_, { headers }) => {
  const appInitials = window.appInitials.toLowerCase()
  const token = localStorage.getItem(appInitials + '_token')
  const lotacao = localStorage.getItem(appInitials + '_lot')
  return {
    headers: {
      ...headers,
      Authorization: token ? `Bearer ${token}` : '',
      lotacao: lotacao ? lotacao : ''
    }
  }
})

const httpLink = createHttpLink({
  uri: `${window.lotacaoBaseUrl}/api/graphql`
})

const cache = new InMemoryCache({
  addTypename: false
})

const defaultOptions = {
  watchQuery: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'ignore'
  },
  query: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all'
  }
}

const lotacaoClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: cache,
  defaultOptions: defaultOptions
})

export { lotacaoClient }
